export default __webpack_public_path__ + "static/media/plugging-1.5b874646.png";